export default __webpack_public_path__ + "correct.4be9e7.mp3";